import { BackendConfigSettingsInterface } from 'common/data/backend/config/settings.interface';

/**
 * Returns bundle settings
 */
export function configGetSettings<T extends BackendConfigSettingsInterface>(): T {
  return window.propertyfinder ? <T>window.propertyfinder.settings : <T>{};
}
